import "jquery.mb.ytplayer";
import "owl.carousel";

document.addEventListener("DOMContentLoaded", () => {
    // Initialisation de la vidéo en arrière plan
    $("#videoFond").YTPlayer();
    jQuery("#videoFond").on("YTPReady", function (e) {
        $("#spinnerVideo").hide();
    });

    // Gestion du carousel des actualités
    $(".tematik_page_list--actusHome").owlCarousel({
        items: 1,
        center: false,
        loop: true,
        margin: 20,
        dots: true,
        nav: true,
        mouseDrag: true,
        navText: [
            '<i class="icon-arrow_left"></i>',
            '<i class="icon-arrow_right"></i>'
        ],
        navClass: ["custom-prev", "custom-next"],
        responsive: {
            576: {
                items: 2,
                mouseDrag: true,
                center: false
            },
            991: {
                items: 3,
                mouseDrag: false
            }
        }
    });
});
